export default "__VITE_ASSET__D5_nO3iP__"